import floor from 'lodash/floor';

var BILLION = 1000000000;
var MILLION = 1000000;
var TEN_THOUSAND = 10000;
var THOUSAND = 1000;
var formatBigNumbersWithSuffix = function formatBigNumbersWithSuffix(value) {
  var isMillions = value >= MILLION;
  var isTenThousands = value >= TEN_THOUSAND;
  var isBillions = value >= BILLION;
  // if value is >= 1B display suffix with 'B+'.
  if (isBillions) {
    var roundedBillions = floor(value / BILLION, 1);
    var actualBillions = value / BILLION;
    return "".concat(roundedBillions, "B").concat(actualBillions > roundedBillions ? '+' : '');
  }
  // if value is >= 1M display suffix with 'M' or 'M+'
  if (isMillions) {
    var roundedMillions = floor(value / MILLION, 1);
    var actualMillions = value / MILLION;
    return "".concat(roundedMillions, "M").concat(actualMillions > roundedMillions ? '+' : '');
  }
  // if value is >= 10k and <999k display suffix with 'K' or 'K+'.
  if (isTenThousands) {
    var roundedHundreds = floor(value / THOUSAND, 1);
    var actualHundreds = value / THOUSAND;
    return "".concat(roundedHundreds, "K").concat(actualHundreds > roundedHundreds ? '+' : '');
  }
  // if value below <10k, just display the original value.
  return value.toLocaleString();
};

export { formatBigNumbersWithSuffix };
